module.exports = __webpack_public_path__ + "static/media/particlesNotification.ecd200d9.svg";